import styled from "styled-components";

interface SectionProps {
  background?: 'white' | 'gray';
}

export const Section = styled.section<SectionProps>`
  padding: 64px 0;
  background-color: ${props => props.background === 'gray' ? 'var(--gray-lightest)' : 'transparent'};
  margin-left: -160px;
  margin-right: -160px;
  padding-left: 160px;
  padding-right: 160px;
  position: relative;

  @media (max-width: 960px) {
    margin-left: -40px;
    margin-right: -40px;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 48px;
    padding-bottom: 48px;
  }

  @media (max-width: 768px) {
    margin-left: -20px;
    margin-right: -20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

export const SectionTitle = styled.h2`
  font-weight: 600;
  color: var(--neutral);
  font-size: 2rem;
  width: 100%;
  margin: 0 0 40px 0;
  position: relative;
  display: inline-block;
  letter-spacing: -0.5px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: -12px;
    width: 48px;
    height: 3px;
    background: linear-gradient(90deg, var(--primary) 0%, var(--primary-light) 100%);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 32px;

    &::before {
      width: 40px;
      height: 2px;
      bottom: -10px;
    }
  }
`;
